import logger from '3-foundation/Logging/logger';
import { mapFirstLink } from '../DataTypes/linkMapper';
import { getEvents } from '3-foundation/Events/repository';

interface Props {
	content: {
		properties: {
			title: string;
			eventsDataSource: Umbraco.TreeNode[];
			quantity: number;
			filter: {
				name: string;
			}[];
			link: Umbraco.Link[];
		};
	};
	siteId: string;
	locale: string;
}

export const mapEventList = async ({ content, siteId, locale }: Props): Promise<Content.EventList> => {
	const { title, eventsDataSource, quantity, filter, link } = content?.properties ?? {};
	try {
		if (eventsDataSource?.length == 0 || !eventsDataSource) {
			logger.error('Event data source is missing');
			throw new Error('Event data source is missing');
		}
		const { items } = await getEvents({
			filters: {
				parentId: eventsDataSource?.[0]?.id,
				tagsSubject: filter?.length ? [filter?.[0]?.name] : null,
			},
			limit: quantity,
			siteId,
			locale,
		});
		return {
			documentType: 'eventList',
			content: {
				title: title || null,
				events: items || null,
				link: mapFirstLink(link),
			},
		};
	} catch (e) {
		logger.error(`Could not map EventList \nCause: ${e}`);
		// Fail silently
		return {
			documentType: 'eventList',
			content: {
				title: null,
				events: null,
				link: null,
			},
		};
	}
};
